import DOMPurify from 'dompurify';
import parseHtml from 'react-html-parser';

// Reverse-tabnabbing protection: any link that opens a new tab gets a safe rel.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target')) {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Tags/attributes that cover the rich-text editor's output (bold/italic/underline/
// lists/links + common formatting) while excluding anything script-capable.
// DOMPurify additionally strips event handlers (onerror, onclick, ...) and unsafe
// URI schemes (javascript:, data:) from whatever is allowed below.
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'a',
    'b',
    'strong',
    'i',
    'em',
    'u',
    's',
    'strike',
    'mark',
    'small',
    'p',
    'br',
    'span',
    'div',
    'hr',
    'blockquote',
    'pre',
    'code',
    'ul',
    'ol',
    'li',
    'sub',
    'sup',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
};

/**
 * Drop-in replacement for the `react-html-parser` default export. It sanitizes the
 * HTML with DOMPurify BEFORE parsing it into React nodes, neutralizing stored XSS
 * (e.g. `<img src=x onerror="...">`, `<script>`, `javascript:` links) in user-supplied
 * rich-text content while preserving legitimate formatting.
 *
 * Imported under the name `ReactHtmlParser` so existing `ReactHtmlParser(value)` call
 * sites need no changes — only the import source switches to this module.
 */
const ReactHtmlParser = (source?: string | null, options?: any) => {
  const clean = DOMPurify.sanitize(source == null ? '' : String(source), SANITIZE_CONFIG);
  return parseHtml(clean, options);
};

export default ReactHtmlParser;
